module.exports = __webpack_public_path__ + "static/media/226-east-timor.135038ee.svg";